import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Convert Blob error responses (responseType:'blob' + HTTP erro) para JSON/text.
    // Sem isto, acessar error.response.data.detail num Blob dispara o erro XHR
    // "Failed to read responseText" e quebra o webpack-dev-server overlay.
    if (error?.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        try {
          error.response.data = JSON.parse(text);
        } catch {
          error.response.data = text;
        }
      } catch {
        // nada a fazer se nao conseguir ler
      }
    }
    if (error.response?.status === 401) {
      // Only clear token, don't force redirect
      // React's ProtectedRoute will handle navigation gracefully
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export default api;